import ContentBlock from "../ContentBlock/ContentBlock";
import ProductBanner from "../ProductBanner/ProductBanner";

export default function Product({ background, productContent, productBanner }) {
  return (
    <section className={`ob-product ${background ? background : ""}`}>
      <ProductBanner params={productBanner} />

      {productContent.map((content) => {
        return <ContentBlock key={content.id} params={content} />;
      })}
    </section>
  );
}
